import React from 'react';
import {EmailAuthenticationResultsProps} from './EmailAuthenticationResults.props';
import './EmailAuthenticationResults.styles.css'
import WarningIcon from "@mui/icons-material/Warning";
import Skeleton from "@mui/material/Skeleton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {checkStatus} from "../../../utils/common";
import { HEADER_PARSING_STATUS_DISPLAY } from "../../../constants/contants";
import { Divider } from "@mui/material";

export const EmailAuthenticationResults: React.FC<EmailAuthenticationResultsProps> = ({
    title,
    payload={},
  }) => {
  const highlightTitleContent = (params: string[]) => {
    const formattedData = params?.map((item: string, index) => {
      const [beforeColon, afterColon] = item.split(/:(.+)/); // Tách chuỗi tại dấu `:`
      return (<>
          <div key={index}>
            <p style={{fontWeight: 700, fontSize: 14, margin: 0, lineHeight: '22.4px'}}>{beforeColon}:</p>
            {afterColon}
          </div>
          <br/>
        </>
      );
    });

    return <div>{formattedData}</div>;
  }

  const cardStatus = (data: any) => {
    const {result, hint} = data;
    const resultKey = result?.toLowerCase();
    return (
      <div className={`record-container ${checkStatus(resultKey)}`}>
        <div className={`desc-content ${checkStatus(resultKey)}`}>
          <div className={`record-status ${checkStatus(resultKey)}`}>
            {checkStatus(resultKey) === 'pass' ? <CheckCircleIcon/> : <CancelIcon/>}
            <span>{HEADER_PARSING_STATUS_DISPLAY[resultKey]}</span><span style={{fontWeight: 700, fontSize: 16, color: 'black'}}> - {hint}</span>
          </div>
          <div className={'record-desc'}>
            {payload?.content || ''}
            {title === 'DKIM' && <>
              <Divider/>
              <p className="dkim-domain-status">Domain <strong id="domain-status">{data['dkim_header']?.toLowerCase() || 'nomatch'}</strong> - The “d=” domain {data['dkim_header'] === 'matching' ? 'matches' : 'does NOT match'} the “From:” domain.</p>
            </>}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={'email-authentication-results-container'}>
        {cardStatus(payload)}
          {title === 'SPF' ? (<>
            <p style={{margin: '32px 0 8px', fontWeight: 700, fontSize: 14}}>Email from and sending server:</p>
            <div className={'email-authentication-results-container'} style={{margin: 0, padding: '16px'}}>
              Email from <span className={'verifier-value'}>{payload?.domain ?? 'N/A'}</span> originates from the sending
              server <span className={'verifier-value'}>{payload?.ip ?? 'N/A'}</span>
            </div>
          </>) : title === 'ARC' ? (
            <p style={{margin: 0, fontWeight: 700, fontSize: 14}}>
                Domain: <span className="verifier-value">{payload?.oldest_pass?.domain?.trim() || 'N/A'}</span>
            </p>
          ) : (
          <p style={{margin: 0, fontWeight: 700, fontSize: 14}}>Domain: <span
            className={'verifier-value'}>{
              payload?.domain?.trim()
                ? payload.domain
                : payload?.oldest_signature?.domain?.trim()
                  ? payload.oldest_signature.domain
                  : 'N/A'
          }</span></p>)
        }
        <p style={{margin: '32px 0 8px', fontWeight: 700, fontSize: 14}}>Related Email Headers:</p>
          <div className={'email-authentication-results-container'} style={{ margin: 0, padding: '16px' }}>
            {payload?.headers_used?.length > 0 ? highlightTitleContent(payload?.headers_used) : 'N/A'}
          </div>
        {title === 'SPF' && <>
            <p style={{ margin: '32px 0 8px', fontWeight: 700, fontSize: 14 }}>Related DNS records:</p>
            <div className={'email-authentication-results-container'} style={{margin: 0, padding: '16px'}}>
              {payload?.spf_record || 'N/A'}
            </div>
        </>}
      </div>
    </>
  );
};
